export default function ({ store, redirect }) {
  const user = store.getters["auth/getUser"]
  if (!user) return

  if (user && user.is_admin === 0) {
    return redirect("/errors/403")
  }
}
